import { RowChanges } from "./row-changes";
import { TableRow } from "./table-row";

export class EditedRows {
  rows: RowChanges; 

  constructor() {
    this.rows = new RowChanges();
  }

  addRow(rowId: string, rowData: TableRow) {
    this.rows.set(rowId, rowData);
  }

  getRow(rowId: string) {
    return this.rows.get(rowId);
  }
  removeRow(rowId: string) {
    this.rows.delete(rowId);
  }
}